// extracted by css-extract-rspack-plugin
export default {"labelDescriptionTooltip":"Label-module__labelDescriptionTooltip__kWymG","tooltipHidden":"Label-module__tooltipHidden__NJKgK"};